import { render, staticRenderFns } from "./download.vue?vue&type=template&id=639aa600&scoped=true&"
import script from "./download.vue?vue&type=script&lang=js&"
export * from "./download.vue?vue&type=script&lang=js&"
import style0 from "./download.vue?vue&type=style&index=0&id=639aa600&lang=less&scoped=true&"
import style1 from "./download.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639aa600",
  null
  
)

component.options.__file = "download.vue"
export default component.exports